import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { HttpErrorResponse } from '@angular/common/http';
import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/angular';
import { SENTRY_DIST, SENTRY_RELEASE } from './sentry.release';
import { environment } from './app/environments/environment';

Sentry.init({
  dsn: 'https://d0192d21c714cc24b0ccc5cfca357f5e@o4509347002253312.ingest.us.sentry.io/4510874650804224',
  release: SENTRY_RELEASE,
  dist: SENTRY_DIST,
  environment: 'production',
  enabled: environment.production,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
  tracePropagationTargets: ['localhost', /^https:\/\/admin\.bonnapp\.com\.br/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    /ResizeObserver loop/i,
    /Non-Error promise rejection/i,
    /NetworkError when attempting to fetch resource/i,
    /Failed to fetch dynamically imported module/i,
    /^Load failed$/i,
  ],
  beforeSend(event, hint) {
    const err = hint?.originalException as unknown;
    if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
      return null;
    }
    return event;
  },
});

if (typeof localStorage !== 'undefined') {
  const restoredId =
    localStorage.getItem('id') || sessionStorage.getItem('id');
  if (restoredId) {
    Sentry.setUser({ id: restoredId });
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
